/* WOOF Gulf — shared behaviour for custom sections */
(function () {
  'use strict';

  /* ---------- reveal on scroll ---------- */
  /* Anything already inside the first viewport is shown at once and without a
     transition. Animating it would mean a visible pop on every navigation,
     which is exactly what the scroll reveal is meant to avoid. */
  function releaseAbove(els) {
    var h = window.innerHeight || 800;
    els.forEach(function (el) {
      if (el.getBoundingClientRect().top < h * 0.95) {
        el.classList.add('w-rev-now', 'w-rev-bound');
      }
    });
  }

  function initReveal(root) {
    var els = [].slice.call((root || document).querySelectorAll('.w-rev:not(.w-rev-bound)'));
    if (!els.length) return;
    releaseAbove(els);
    els = els.filter(function (el) { return !el.classList.contains('w-rev-bound'); });
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('on', 'w-rev-bound'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target;
        var sibs = Array.prototype.slice.call(el.parentNode.children).filter(function (n) {
          return n.classList && n.classList.contains('w-rev');
        });
        el.style.transitionDelay = Math.min(sibs.indexOf(el), 5) * 70 + 'ms';
        el.classList.add('on');
        io.unobserve(el);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

    els.forEach(function (el) {
      el.classList.add('w-rev-bound');
      io.observe(el);
    });
  }

  /* ---------- full-bleed: neutralise Horizon's narrow page wrapper ---------- */
  function unwrap() {
    document.querySelectorAll('.woof-sec').forEach(function (sec) {
      var node = sec.parentElement;
      while (node && node !== document.body) {
        var cs = getComputedStyle(node);
        if (cs.maxWidth !== 'none' || parseFloat(cs.paddingInlineStart) > 0) {
          node.style.maxWidth = 'none';
          node.style.paddingInlineStart = '0';
          node.style.paddingInlineEnd = '0';
        }
        node = node.parentElement;
      }
    });
  }

  function boot() {
    unwrap();
    initReveal();
  }

  /* Run as early as the DOM allows. The script is deferred, so by the time it
     executes the document is parsed but not yet painted — releasing the
     above-the-fold elements here means the first paint is already correct. */
  boot();
  document.addEventListener('DOMContentLoaded', boot);
  window.addEventListener('pageshow', boot);

  /* re-run inside the theme editor */
  document.addEventListener('shopify:section:load', function (e) {
    unwrap();
    initReveal(e.target);
  });
})();
